// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchInput_input__3IHG8"};